import { render, staticRenderFns } from "./PanelCompetitionSettingRegister.vue?vue&type=template&id=df28a9a4&scoped=true&"
import script from "./PanelCompetitionSettingRegister.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingRegister.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionSettingRegister.vue?vue&type=style&index=0&id=df28a9a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df28a9a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df28a9a4')) {
      api.createRecord('df28a9a4', component.options)
    } else {
      api.reload('df28a9a4', component.options)
    }
    module.hot.accept("./PanelCompetitionSettingRegister.vue?vue&type=template&id=df28a9a4&scoped=true&", function () {
      api.rerender('df28a9a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionSettingRegister.vue"
export default component.exports